var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHeartFilled = function SvgHeartFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "heart"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m11.75 5.984.584-.583a4.783 4.783 0 0 1 7.661 1.243 4.779 4.779 0 0 1-.885 5.51l-6.818 7.114a.753.753 0 0 1-1.083 0l-6.807-7.1A4.783 4.783 0 1 1 11.167 5.4l.583.583z"
  })));
};
export default SvgHeartFilled;